import React from 'react';

type Props = {
  title?: string | undefined | null;
  subTitle?: string | undefined | null;
};

export default function PageLoading({ title, subTitle }: Props) {
  return (
    <div className="d-flex items-center justify-content-center flex-column position-absolute w-100 h-100 bg-white">
      <div>
        <img src={require('@/assets/loading.gif')} style={{ height: 100 }} alt="loading" />
      </div>
      {title ? <div className="fw-500 text-22 mt-5">{title}</div> : null}
      {subTitle ? <div className="mt-5 text-16">{subTitle}</div> : null}
    </div>
  );
}
